export const R7_WOPI_IFRAME_ID = 'R7_WOPI_IFRAME_ID';
